export const setDigitalCertificate = (state, payload) => state.digital_certificate = payload;
